import MaterialTable from "@material-table/core";
import { useEffect, useState } from "react";
import { log } from "../../Helper";
import _ from "lodash";
import { BLUE, CODE_AVIS, CODE_BLUE, CODE_GREEN, CODE_JD_LINK, CODE_MAINCHAIN, CODE_YELLOW, GREEN, YELLOW, CODE_RED, RED, CODE_FORWARDER } from "../orders/utility/constants";

const SelectedMachinesTable = ({ selectedMachinesForBuild, arrivalDateSwitchState, caller, onArrivalDateChange }) => {
  const modalColumn = [
    {
      title: "FROM",
      field: "from",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "SHIP ORDER",
      field: "shpOrder",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "LOAD BUILD",
      field: "loadbuild",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
      hidden: caller === 'EditBuild' ? false : true,
    },
    {
      title: "PLANNED LOADING DATE",
      field: "asn",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "TO COUNTRY",
      field: "toCountry",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "TO CITY",
      field: "toCity",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "",
      field: "build",
      hidden: true,
    },
    {
      title: "COMAR",
      field: "zcomar",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "ARRIVAL DATE",
      field: "estimatedArrivalDate",
      render: (rowData) => {
        let color = rowData.colorArrivalDate === GREEN ? CODE_GREEN : rowData.colorArrivalDate === BLUE
            ? CODE_BLUE : rowData.colorArrivalDate === YELLOW ? CODE_YELLOW 
            : rowData.colorArrivalDate === RED ? CODE_RED : "";
        
            let hoverText = color === CODE_GREEN ? CODE_JD_LINK : color === CODE_BLUE ? CODE_MAINCHAIN : 
            color === CODE_YELLOW? CODE_AVIS : color === CODE_RED ? CODE_FORWARDER : "";
        return (
          <input name="departureDate"
            type="date"
            disabled={!arrivalDateSwitchState}
            className={`border-2 rounded ${estimatedArrivalDateSwitch ? 'border-green-700' : 'border-gray-300'}`}
            // min={minDate}
            max={new Date().toISOString().slice(0, 10)}
            defaultValue={(null != rowData.finalArrivalDate && !_.isEmpty(rowData.finalArrivalDate) && estimatedArrivalDateSwitch) ?
              rowData.finalArrivalDate : null}
            style={{ backgroundColor : color }}
            onBlur={(e) => handleBlur(rowData, e)}
            title={ hoverText }
          />
        );
      },
      editable: "always",
      headerStyle: {
        fontSize: "12px",
      },
      hidden: caller === 'ReportPickup' ? false : true,
    },
  ];

  // Report arrivale date switch loaded on use effect
  useEffect(() => {
    setEstimatedArrivalDateSwitch(arrivalDateSwitchState);
  }, [arrivalDateSwitchState]);

  const handleBlur = (rowData, e) => {
    if(e.target.value!== ""){
      rowData.finalArrivalDate = e.target.value;
    } else {
      rowData.finalArrivalDate = null;
    }
    
    // Notify parent component of the change
    if (onArrivalDateChange) {
      onArrivalDateChange(rowData.orderPathId, rowData.finalArrivalDate);
    }
  };

  const [estimatedArrivalDateSwitch, setEstimatedArrivalDateSwitch] = useState('');
  const data = [...selectedMachinesForBuild];

  let minDate = new Date(new Date().setMonth(new Date().getMonth() - 6))
    .toISOString()
    .slice(0, 10);
  let maxDate = new Date(new Date().setMonth(new Date().getMonth() + 3))
    .toISOString()
    .slice(0, 10);

  return (
    <>
    <MaterialTable
      options={{
        rowStyle: {
          fontSize: '11px',
          padding: '4px 8px',
        },
        selection: false,
        search: false,
        showTitle: false,
        sorting: false,
        paging: false,
        toolbar: false,
        draggable: false,
        headerStyle: {
          backgroundColor: "#367c2b",
          fontWeight: "600",
          color: "white",
          fontSize: "11px",
          padding: "8px 12px",
          textAlign: "center",
        },
        filterCellStyle: {
          flex: 1
        },
      }}
      columns={modalColumn}
      data={data}
    />
    </>
  );
};


export default SelectedMachinesTable;